import type { Dialog } from '@common/types'
import { stringify as stringifyQs } from 'qs'
import urlJoin from 'url-join'

export const playbookSection = '/playbooks/'

export type PlaybookListUrlDialog = 'new'

export type PlaybookListUrlQueryParams = Dialog<PlaybookListUrlDialog>

export const playbookListUrl = (params?: PlaybookListUrlQueryParams): string => {
  if (params === undefined) {
    return playbookSection
  }

  return urlJoin(playbookSection, '?' + stringifyQs(params))
}

export const playbookDetailPath = ':id'

export type PlaybookDetailUrlDialog = 'new-version' | 'view-version'

export type PlaybookDetailUrlQueryParams = Dialog<PlaybookDetailUrlDialog> &
  // The `view-version` dialog carries which version to open read-only.
  Partial<{ version: string }>

export const playbookDetailUrl = (id: string, params?: PlaybookDetailUrlQueryParams): string => {
  const base = urlJoin(playbookSection, encodeURIComponent(id))
  if (params === undefined) {
    return base
  }

  return urlJoin(base, '?' + stringifyQs(params))
}
